/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Text, EmptyState, BrandColors, LoadingSpinner } from '@blend/enterprise-components';
import { SECTION_TYPES } from '../../types';
import type { ReduxProps } from './EmptyThreadSectionContainer';
import { useContext } from 'react';
import { InboxContext } from '../Inbox/InboxContext';

const styles = StyleSheet.create({
  emptyTableWrapper: {
    backgroundColor: BrandColors.WHITE,
    border: `1px solid ${BrandColors.CLOUD_50}`,
    display: 'flex',

    justifyContent: 'center',
    padding: '60px 0',
  },
  padding: {
    padding: '20px 14px',
  },
});

export namespace EmptyThreadSection {
  export interface Props {
    header: SECTION_TYPES;
  }
}

export const EmptyThreadSection: React.FC<EmptyThreadSection.Props & ReduxProps> = ({ isInitialLoad, header }) => {
  const {
    stylingConfig: { additionalPadding },
  } = useContext(InboxContext);

  switch (header) {
    case SECTION_TYPES.outstanding:
      return (
        <div className={css(styles.emptyTableWrapper)}>
          {isInitialLoad ? <LoadingSpinner size="lg" theme="secondary" /> : <EmptyState header="No messages" />}
        </div>
      );
    case SECTION_TYPES.resolved:
      return (
        <div className={css(additionalPadding && styles.padding)}>
          <Text colorName="NIGHT_80" fontSize="md">
            Nothing resolved yet.
          </Text>
        </div>
      );
  }
};
